<template>
  <v-app-bar app>
    <template v-slot:prepend>
      <router-link to="/">
        <img :src="logoImage" alt="logo" style="height: 40px;">
      </router-link>
    </template>
    <v-app-bar-title class="headline text-uppercase">
      <span>{{ branca }}</span>
      <span class="font-weight-light">SIM</span>
    </v-app-bar-title>


    <!-- Botón del menú hamburguesa para móviles -->
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon rounded="0" v-bind="props" class="h-100 hidden-sm-and-up">
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- Botón Explora -->
        <v-list-item @click="selectButton('aprende', '/')">
          <v-btn flat rounded="0" class="h-100" :color="selectedButton === 'aprende' ? 'primary' : 'default'">
            {{ t('Aprende') }}
          </v-btn>
        </v-list-item>

        <!-- Botón Inspira -->
        <v-list-item @click="selectButton('inspira', '/inspira')">
          <v-btn flat rounded="0" class="h-100" :color="selectedButton === 'inspira' ? 'primary' : 'default'">
            {{ t('Inspira') }}
          </v-btn>
        </v-list-item>
        <!-- Botón Itinerario -->
        <v-list-item @click="selectButton('itinerario', '/itinerario')">
          <v-btn flat rounded="0" class="h-100" :color="selectedButton === 'itinerario' ? 'primary' : 'default'">
            {{ t('Itinerario') }}
          </v-btn>
        </v-list-item>
        <!-- Botón Admin -->
        <v-list-item @click="selectButton('admin', '/administrador')">
          <v-btn v-if="isAdmin" flat rounded="0" class="h-100"
            :color="selectedButton === 'admin' ? 'primary' : 'default'">
            Admin
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Botons desktop -->
    <v-btn flat rounded="0" class="h-100 hidden-xs" :color="selectedButton === 'aprende' ? 'primary' : 'default'"
      @click="selectButton('aprende', '/')">
      {{ t('Aprende') }}
    </v-btn>
    <v-btn flat rounded="0" class="h-100 hidden-xs" :color="selectedButton === 'inspira' ? 'primary' : 'default'"
      @click="selectButton('inspira', '/inspira')">
      {{ t('Inspira') }}
    </v-btn>
    <v-btn flat rounded="0" class="h-100 hidden-xs" :color="selectedButton === 'itinerario' ? 'primary' : 'default'"
      @click="selectButton('itinerario', '/itinerario')">
      {{ t('Itinerario') }}
    </v-btn>
    <!-- Botón Admin -->
    <v-btn v-if="isAdmin" flat rounded="0" class="h-100 hidden-xs"
      :color="selectedButton === 'admin' ? 'primary' : 'default'" @click="selectButton('admin', '/administrador')">
      Admin
    </v-btn>

    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn flat v-bind="props" rounded="0" class="h-100 hidden-xs">
          <v-icon>mdi-translate</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="setLocale('ca')">
          <v-list-item-title>Català</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setLocale('en')">
          <v-list-item-title>English</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setLocale('es')">
          <v-list-item-title>Español</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn flat v-bind="props" rounded="0" class="h-100" prepend-icon="mdi-account">
          <span class="d-none d-sm-inline">{{ userDetails?.nickname || 'Usuario' }}</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item :to="`/perfil`" @click="resetButtons" prepend-icon="mdi-account-edit">
          <v-list-item-title>{{ t('Perfil') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="`/reservas`" @click="resetButtons" prepend-icon="mdi-calendar-month">
          <v-list-item-title>{{ t('Tus_reservas') }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="hidden-sm-and-up" prepend-icon="mdi-translate">{{ t('Idioma') }}
          <v-menu activator="parent">
            <v-list>
              <v-list-item @click="setLocale('ca')">
                <v-list-item-title>Català</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setLocale('en')">
                <v-list-item-title>English</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setLocale('es')">
                <v-list-item-title>Español</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
        <v-list-item @click="logout" prepend-icon="mdi-logout">{{ t('Cerrar_sesión') }}</v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { axios } from '../axios'
import { useUserStore } from '@/stores/user';

// Define component props
const { branca, logoImage } = defineProps({
  branca: String,
  logoImage: String,
})


// Initialize store and router
const userStore   = useUserStore();
const router = useRouter()
const { t, locale } = useI18n()

// Retrieve stored locale from localStorage (if available)
const userLocale = localStorage.getItem('userLocale')
if (userLocale) {
  locale.value = userLocale
}

// Local state
const selectedButton = ref(null)

// Retrieve userDetails from the store as a computed property
const userDetails = computed(() => userStore.userDetails);
const isAdmin = computed(() => {
  return userDetails.value ? userDetails.value.admin : false;
});


// Function to select a button and navigate to a specified path
const selectButton = (button, path) => {
  selectedButton.value = button
  router.push(path)
}

// Function to reset selected button state
const resetButtons = () => {
  selectedButton.value = null
}

// Function to log out the user
const logout = async () => {
  const formData = new FormData()
  try {
    const response = await axios.post(`logout/`, formData)
    console.log('Respuesta del servidor:', response.data)
    localStorage.removeItem('authToken')
    router.push('/login')
  } catch (error) {
    console.error('Hubo un error al cerrar sesión: ', error)
  }
}

// Function to update the locale and persist it in localStorage
const setLocale = (newLocale) => {
  locale.value = newLocale
  localStorage.setItem('userLocale', newLocale)
}
</script>